
// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { ref, get } from 'firebase/database';
// import { db } from '../firebase';
// import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { motion, AnimatePresence } from 'framer-motion';

// const LuxuryProductSlider = () => {
//   const navigate = useNavigate();
//   const [slides, setSlides] = useState([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isHovered, setIsHovered] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [screenSize, setScreenSize] = useState({
//     isMobile: window.innerWidth < 768,
//     isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
//     isDesktop: window.innerWidth >= 1024,
//     isLargeDesktop: window.innerWidth >= 1440,
//     width: window.innerWidth,
//     height: window.innerHeight
//   });
//   const sliderRef = useRef(null);
//   const intervalRef = useRef(null);

//   // Luxury Color Palette
//   const colors = {
//     primary: '#1a1a2e',
//     secondary: '#16213e',
//     accent: '#e6b422',
//     background: '#f8f5f2',
//     textLight: 'rgba(255, 255, 255, 1)',
//     textMuted: 'rgba(255,255,255,0.7)',
//     overlay: 'rgba(26, 26, 46, 0.85)',
//     glass: 'rgba(255, 255, 255, 0.1)'
//   };

//   useEffect(() => {
//     const handleResize = () => {
//       const width = window.innerWidth;
//       const height = window.innerHeight;
//       setScreenSize({
//         isMobile: width < 768,
//         isTablet: width >= 768 && width < 1024,
//         isDesktop: width >= 1024,
//         isLargeDesktop: width >= 1440,
//         width,
//         height
//       });
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   useEffect(() => {
//     const fetchSlides = async () => {
//       try {
//         const slidesRef = ref(db, 'Watch/admin/slider/images');
//         const snapshot = await get(slidesRef);
//         if (snapshot.exists()) {
//           const slidesData = Object.entries(snapshot.val()).map(([id, slide]) => ({
//             id,
//             ...slide,
//           }));
//           setSlides(slidesData);
//         }
//       } catch (error) {
//         toast.error('Failed to load images');
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchSlides();
//   }, []);

//   useEffect(() => {
//     if (slides.length > 1 && !isHovered) {
//       intervalRef.current = setInterval(() => {
//         setDirection(1);
//         setCurrentIndex(prev => (prev + 1) % slides.length);
//       }, 5000);
//     } else {
//       clearInterval(intervalRef.current);
//     }
//     return () => {
//       if (intervalRef.current) {
//         clearInterval(intervalRef.current);
//         intervalRef.current = null;
//       }
//     };
//   }, [slides.length, isHovered]);

//   // Cleanup interval on unmount
//   useEffect(() => {
//     return () => {
//       if (intervalRef.current) {
//         clearInterval(intervalRef.current);
//         intervalRef.current = null;
//       }
//     };
//   }, []);

//   const [direction, setDirection] = useState(0);

//   const goToSlide = (index) => {
//     setDirection(index > currentIndex ? 1 : -1);
//     setCurrentIndex(index);
//   };

//   const goToNext = () => {
//     setDirection(1);
//     setCurrentIndex(prev => (prev + 1) % slides.length);
//   };

//   const goToPrev = () => {
//     setDirection(-1);
//     setCurrentIndex(prev => (prev - 1 + slides.length) % slides.length);
//   };

//   // Touch swipe functionality for mobile
//   const [touchStart, setTouchStart] = useState(null);
//   const [touchEnd, setTouchEnd] = useState(null);

//   const minSwipeDistance = 50;

//   const onTouchStart = (e) => {
//     setTouchEnd(null);
//     setTouchStart(e.targetTouches[0].clientX);
//   };

//   const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);

//   const onTouchEnd = () => {
//     if (!touchStart || !touchEnd) return;
//     const distance = touchStart - touchEnd;
//     const isLeftSwipe = distance > minSwipeDistance;
//     const isRightSwipe = distance < -minSwipeDistance;

//     if (isLeftSwipe && slides.length > 1) {
//       goToNext();
//     } else if (isRightSwipe && slides.length > 1) {
//       goToPrev();
//     }

//     // Reset touch states
//     setTouchStart(null);
//     setTouchEnd(null);
//   };

//   const slideVariants = {
//     enter: (direction) => ({
//       opacity: 0,
//       x: direction > 0 ? 1000 : -1000,
//       scale: 0.95
//     }),
//     center: {
//       opacity: 1,
//       x: 0,
//       scale: 1
//     },
//     exit: (direction) => ({
//       opacity: 0,
//       x: direction < 0 ? 1000 : -1000,
//       scale: 0.95
//     }),
//   };

//   const getResponsiveStyles = () => {
//     const { isMobile, isTablet, isDesktop, isLargeDesktop, width, height } = screenSize;

//     const containerHeight = isMobile ? height : '100vh';
//     const navButtonSize = isMobile ? 50 : isTablet ? 55 : 60;
//     const navButtonPosition = isMobile ? 15 : isTablet ? 25 : 40;
//     const contentPadding = isMobile ? 15 : isTablet ? 25 : 40;
//     const overlayPadding = isMobile ? '15px' : isTablet ? '5%' : '10%';

//     return {
//       sliderContainer: {
//         position: 'relative',
//         width: '100%',
//         height: containerHeight,
//         overflow: 'hidden',
//         minHeight: isMobile ? '100vh' : '70vh',
//       },
//       slideContainer: {
//         position: 'relative',
//         width: '100%',
//         height: '90%',
//       },
//       imageWrapper: {
//         position: 'absolute',
//         width: '100%',
//         height: '100%',
//         overflow: 'hidden',
//       },
//       productImage: {
//         width: '100%',
//         height: '100%',
//         objectFit: isMobile ? 'cover' : 'cover',
//         objectPosition: 'center',
//         transition: 'transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)',
//         transform: isHovered && !isMobile ? 'scale(1.03)' : 'scale(1)',
//       },
//       overlay: {
//         position: 'absolute',
//         top: 0,
//         left: 0,
//         width: '100%',
//         height: '100%',
//         background: isMobile
//           ? `linear-gradient(to bottom, transparent 0%, ${colors.overlay} 60%)`
//           : `linear-gradient(to right, ${colors.overlay} 0%, transparent 100%)`,
//         display: 'flex',
//         alignItems: isMobile ? 'flex-end' : 'center',
//         justifyContent: isMobile ? 'center' : 'flex-start',
//         padding: overlayPadding,
//         paddingBottom: isMobile ? '120px' : overlayPadding,
//       },
//       contentContainer: {
//         maxWidth: (() => {
//           if (isMobile) return width <= 480 ? '90%' : '85%';
//           if (isTablet) return '70%';
//           if (isLargeDesktop) return '700px';
//           return '600px';
//         })(),
//         width: isMobile ? '100%' : 'auto',
//         padding: contentPadding,
//         background: colors.glass,
//         backdropFilter: 'blur(10px)',
//         borderRadius: isMobile ? '12px' : '16px',
//         border: `1px solid rgba(255,255,255,0.1)`,
//         boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
//         transform: isHovered && !isMobile ? 'translateY(-10px)' : 'translateY(0)',
//         transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
//         textAlign: isMobile ? 'center' : 'left',
//       },
//       productTitle: {
//         fontSize: (() => {
//           if (isMobile) return width <= 480 ? '1.8rem' : '2.2rem';
//           if (isTablet) return '2.8rem';
//           if (isLargeDesktop) return '4.5rem';
//           return '4rem';
//         })(),
//         fontWeight: 300,
//         color: colors.textLight,
//         marginBottom: isMobile ? '15px' : '20px',
//         lineHeight: 1.1,
//         letterSpacing: isMobile ? '0.5px' : '1px',
//       },
//       productDescription: {
//         fontSize: (() => {
//           if (isMobile) return width <= 480 ? '0.9rem' : '1rem';
//           if (isTablet) return '1.1rem';
//           return '1.2rem';
//         })(),
//         fontWeight: 300,
//         color: colors.textMuted,
//         marginBottom: isMobile ? '25px' : '40px',
//         lineHeight: 1.6,
//         display: isMobile && width <= 480 ? '-webkit-box' : 'block',
//         WebkitLineClamp: isMobile && width <= 480 ? 3 : 'none',
//         WebkitBoxOrient: 'vertical',
//         overflow: isMobile && width <= 480 ? 'hidden' : 'visible',
//       },
//       priceTag: {
//         display: 'inline-block',
//         background: colors.accent,
//         color: colors.primary,
//         padding: isMobile ? '6px 16px' : '8px 20px',
//         borderRadius: '20px',
//         fontSize: isMobile ? '1rem' : '1.2rem',
//         fontWeight: 500,
//         marginBottom: isMobile ? '20px' : '30px',
//       },
//       ctaButton: {
//         background: 'transparent',
//         color: colors.textLight,
//         border: `2px solid ${colors.accent}`,
//         padding: (() => {
//           if (isMobile) return width <= 480 ? '12px 30px' : '14px 35px';
//           if (isTablet) return '14px 38px';
//           return '15px 40px';
//         })(),
//         fontSize: isMobile ? '0.9rem' : '1rem',
//         fontWeight: 500,
//         letterSpacing: isMobile ? '1px' : '1.5px',
//         cursor: 'pointer',
//         transition: 'all 0.4s ease',
//         borderRadius: '30px',
//         position: 'relative',
//         overflow: 'hidden',
//         width: isMobile ? '100%' : 'auto',
//         maxWidth: isMobile ? '280px' : 'none',
//         touchAction: isMobile ? 'manipulation' : 'auto',
//       },
//       navButton: {
//         position: 'absolute',
//         top: '50%',
//         transform: 'translateY(-50%)',
//         width: navButtonSize,
//         height: navButtonSize,
//         borderRadius: '50%',
//         background: colors.glass,
//         backdropFilter: 'blur(5px)',
//         border: `1px solid rgba(255,255,255,0.2)`,
//         display: isMobile && width <= 480 ? 'none' : 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         cursor: 'pointer',
//         zIndex: 10,
//         color: colors.textLight,
//         left: navButtonPosition,
//         boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
//         touchAction: 'manipulation',
//         WebkitTapHighlightColor: 'transparent',
//       },
//       pagination: {
//         position: 'absolute',
//         bottom: isMobile ? '30px' : '40px',
//         left: '50%',
//         transform: 'translateX(-50%)',
//         display: 'flex',
//         gap: isMobile ? '8px' : '12px',
//         zIndex: 10,
//         padding: isMobile ? '10px' : '0',
//         background: isMobile ? 'rgba(0,0,0,0.1)' : 'transparent',
//         borderRadius: isMobile ? '20px' : '0',
//         backdropFilter: isMobile ? 'blur(5px)' : 'none',
//       },
//       indicator: {
//         width: isMobile ? '8px' : '10px',
//         height: isMobile ? '8px' : '10px',
//         borderRadius: '50%',
//         background: colors.textMuted,
//         cursor: 'pointer',
//         transition: 'all 0.3s ease',
//         touchAction: 'manipulation',
//         border: 'none',
//         outline: 'none',
//       },
//       slideNumber: {
//         position: 'absolute',
//         bottom: isMobile ? '30px' : '40px',
//         right: isMobile ? '20px' : '40px',
//         fontSize: isMobile ? '0.8rem' : '0.9rem',
//         color: colors.textLight,
//         letterSpacing: isMobile ? '1px' : '2px',
//         opacity: 0.7,
//         display: isMobile && width <= 480 ? 'none' : 'block',
//         background: isMobile ? 'rgba(0,0,0,0.2)' : 'transparent',
//         padding: isMobile ? '8px 12px' : '0',
//         borderRadius: isMobile ? '12px' : '0',
//         backdropFilter: isMobile ? 'blur(5px)' : 'none',
//       }
//     };
//   };

//   const sliderStyles = getResponsiveStyles();

//   if (loading) {
//     return (
//       <div style={{
//         height: screenSize.isMobile ? screenSize.height : '100vh',
//         minHeight: screenSize.isMobile ? '100vh' : '70vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: colors.primary
//       }}>
//         <div style={{
//           width: screenSize.isMobile ? '50px' : '60px',
//           height: screenSize.isMobile ? '50px' : '60px',
//           border: `3px solid ${colors.glass}`,
//           borderTopColor: colors.accent,
//           borderRadius: '50%',
//           animation: 'spin 1s linear infinite'
//         }}></div>
//       </div>
//     );
//   }

//   if (slides.length === 0) {
//     return (
//       <div style={{
//         height: screenSize.isMobile ? screenSize.height : '100vh',
//         minHeight: screenSize.isMobile ? '100vh' : '70vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: colors.primary,
//         color: colors.textLight,
//         padding: '20px',
//         textAlign: 'center'
//       }}>
//         <p style={{ fontSize: screenSize.isMobile ? '1rem' : '1.2rem' }}>
//           No products available
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div
//       onMouseEnter={() => !screenSize.isMobile && setIsHovered(true)}
//       onMouseLeave={() => !screenSize.isMobile && setIsHovered(false)}
//       onTouchStart={screenSize.isMobile ? onTouchStart : undefined}
//       onTouchMove={screenSize.isMobile ? onTouchMove : undefined}
//       onTouchEnd={screenSize.isMobile ? onTouchEnd : undefined}
//       style={{
//         ...sliderStyles.sliderContainer,
//         touchAction: screenSize.isMobile ? 'pan-y' : 'auto'
//       }}
//       ref={sliderRef}
//     >
//       <AnimatePresence custom={currentIndex}>
//         <motion.div
//           key={currentIndex}
//           style={sliderStyles.slideContainer}
//           custom={direction}
//           variants={slideVariants}
//           initial="enter"
//           animate="center"
//           exit="exit"
//           transition={{
//             x: { type: "spring", stiffness: 300, damping: 30 },
//             opacity: { duration: 0.4 },
//             scale: { duration: 0.4 }
//           }}
//         >
//           <div style={sliderStyles.imageWrapper}>
//             <img
//               src={slides[currentIndex]?.url}
//               alt={slides[currentIndex]?.altText || 'Luxury product'}
//               style={sliderStyles.productImage}
//               onError={(e) => {
//                 e.target.style.display = 'none';
//                 console.error('Failed to load image:', slides[currentIndex]?.url);
//               }}
//               onLoad={(e) => {
//                 e.target.style.display = 'block';
//               }}
//             />
//           </div>

//           <div style={sliderStyles.overlay}>
//             <motion.div
//               style={sliderStyles.contentContainer}
//               initial={{ opacity: 0, y: 20 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ delay: 0.3, duration: 0.6 }}
//             >
//               <h2
//                 className="slider-title"
//                 style={{
//                 ...sliderStyles.productTitle,
//                 background: 'linear-gradient(90deg, #ff8a00, #e52e71)',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent',
//                 fontSize: screenSize.isMobile ? '2.5rem' : '4rem',
//                 lineHeight: 1.1
//               }}
//               >
//                 {slides[currentIndex]?.title || 'Premium Collection'}
//               </h2>

//               {slides[currentIndex]?.price && (
//                 <div style={sliderStyles.priceTag}>
//                   ${slides[currentIndex]?.price}
//                 </div>
//               )}
//               <p
//                 className="slider-description"
//                 style={sliderStyles.productDescription}
//               >
//                 {slides[currentIndex]?.description || 'Discover our exclusive range of luxury timepieces and eyewear'}
//               </p>

//              <motion.button
//               style={{
//                 ...sliderStyles.ctaButton,
//                 background: 'linear-gradient(90deg, #ff8a00, #e52e71)',
//                 border: 'none',
//                 color: 'white',
//                 fontWeight: 'bold',
//                 letterSpacing: '1px',
//                 textTransform: 'uppercase',
//                 boxShadow: '0 4px 15px rgba(255,138,0,0.4)',
//                 padding: screenSize.isMobile ? '12px 30px' : '15px 40px',
//                 fontSize: screenSize.isMobile ? '0.9rem' : '1rem'
//               }}
//               onClick={() => navigate(slides[currentIndex]?.link || '/Products')}
//               initial={{ opacity: 0, y: 30 }}
//               animate={{ 
//                 opacity: 1, 
//                 y: 0,
//                 transition: { delay: 0.9 }
//               }}
//               whileHover={!screenSize.isMobile ? {
//                 scale: 1.05,
//                 boxShadow: '0 6px 20px rgba(255,138,0,0.6)',
//                 background: 'linear-gradient(90deg, #ff9a00, #f22e81)'
//               } : {}}
//               whileTap={{ scale: 0.95 }}
//             >
//               EXPLORE COLLECTION
//             </motion.button>
//             </motion.div>
//           </div>
//         </motion.div>
//       </AnimatePresence>

//       {!(screenSize.isMobile && screenSize.width <= 480) && (
//         <>
//           <button
//             style={sliderStyles.navButton}
//             onClick={goToPrev}
//             aria-label="Previous slide"
//             onTouchStart={(e) => e.preventDefault()}
//           >
//             <svg
//               width={screenSize.isMobile ? "20" : "24"}
//               height={screenSize.isMobile ? "20" : "24"}
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="2"
//             >
//               <path d="M15 18l-6-6 6-6" />
//             </svg>
//           </button>

//           <button
//             style={{
//               ...sliderStyles.navButton,
//               left: 'auto',
//               right: screenSize.isMobile ? '15px' : screenSize.isTablet ? '25px' : '40px'
//             }}
//             onClick={goToNext}
//             aria-label="Next slide"
//             onTouchStart={(e) => e.preventDefault()}
//           >
//             <svg
//               width={screenSize.isMobile ? "20" : "24"}
//               height={screenSize.isMobile ? "20" : "24"}
//               viewBox="0 0 24 24"
//               fill="none"
//               stroke="currentColor"
//               strokeWidth="2"
//             >
//               <path d="M9 18l6-6-6-6" />
//             </svg>
//           </button>
//         </>
//       )}



//       <div style={sliderStyles.slideNumber}>
//         {String(currentIndex + 1).padStart(2, '0')} / {String(slides.length).padStart(2, '0')}
//       </div>

//       <style>
//         {`
//           @keyframes spin {
//             to { transform: rotate(360deg); }
//           }

//           @keyframes fadeInUp {
//             from {
//               opacity: 0;
//               transform: translateY(30px);
//             }
//             to {
//               opacity: 1;
//               transform: translateY(0);
//             }
//           }

//           @keyframes slideInFromLeft {
//             from {
//               opacity: 0;
//               transform: translateX(-50px);
//             }
//             to {
//               opacity: 1;
//               transform: translateX(0);
//             }
//           }

//           /* Responsive utilities */
//           @media (max-width: 480px) {
//             .slider-title {
//               font-size: 1.8rem !important;
//               line-height: 1.2;
//             }

//             .slider-description {
//               font-size: 0.9rem !important;
//               margin-bottom: 20px !important;
//             }

//             .slider-button {
//               width: 100% !important;
//               max-width: 280px !important;
//               padding: 12px 30px !important;
//             }
//           }

//           @media (min-width: 481px) and (max-width: 767px) {
//             .slider-title {
//               font-size: 2.2rem !important;
//             }

//             .slider-description {
//               font-size: 1rem !important;
//             }
//           }

//           @media (min-width: 768px) and (max-width: 1023px) {
//             .slider-title {
//               font-size: 2.8rem !important;
//             }

//             .slider-description {
//               font-size: 1.1rem !important;
//             }
//           }

//           @media (min-width: 1440px) {
//             .slider-title {
//               font-size: 4.5rem !important;
//             }

//             .slider-description {
//               font-size: 1.3rem !important;
//             }
//           }

//           /* Improve touch interactions */
//           @media (hover: none) and (pointer: coarse) {
//             button {
//               min-height: 44px;
//               min-width: 44px;
//             }
//           }

//           /* Prevent zoom on input focus for iOS */
//           @media screen and (-webkit-min-device-pixel-ratio: 0) {
//             select, textarea, input[type="text"], input[type="password"],
//             input[type="datetime"], input[type="datetime-local"],
//             input[type="date"], input[type="month"], input[type="time"],
//             input[type="week"], input[type="number"], input[type="email"],
//             input[type="url"] {
//               font-size: 16px;
//             }
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default LuxuryProductSlider;





import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ref, get } from 'firebase/database';
import { db } from '../firebase';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { motion, AnimatePresence } from 'framer-motion';

const LuxuryProductSlider = () => {
  const navigate = useNavigate();
  const [slides, setSlides] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const [loading, setLoading] = useState(true);
  const [direction, setDirection] = useState(0);
  const [imagesLoaded, setImagesLoaded] = useState({});
  const [screenSize, setScreenSize] = useState({
    isMobile: window.innerWidth < 768,
    isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
    isDesktop: window.innerWidth >= 1024,
    isLargeDesktop: window.innerWidth >= 1440,
    width: window.innerWidth,
    height: window.innerHeight
  });
  const sliderRef = useRef(null);
  const intervalRef = useRef(null);

  const colors = {
    primary: '#1a1a2e',
    secondary: '#16213e',
    accent: '#e6b422',
    background: '#f8f5f2',
    textLight: 'rgba(255, 255, 255, 1)',
    textMuted: 'rgba(255,255,255,0.7)',
    overlay: 'rgba(26, 26, 46, 0.85)',
    glass: 'rgba(255, 255, 255, 0.1)'
  };

  // Debounced resize handler
  useEffect(() => {
    let resizeTimer;
    const handleResize = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const width = window.innerWidth;
        const height = window.innerHeight;
        setScreenSize(prev => {
          if (Math.abs(prev.width - width) < 10 && Math.abs(prev.height - height) < 10) {
            return prev;
          }
          return {
            isMobile: width < 768,
            isTablet: width >= 768 && width < 1024,
            isDesktop: width >= 1024,
            isLargeDesktop: width >= 1440,
            width,
            height
          };
        });
      }, 150);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      clearTimeout(resizeTimer);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Preload images
  useEffect(() => {
    if (slides.length > 0) {
      slides.forEach((slide, index) => {
        const img = new Image();
        img.onload = () => {
          setImagesLoaded(prev => ({ ...prev, [index]: true }));
        };
        img.src = slide.url;
      });
    }
  }, [slides]);

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const slidesRef = ref(db, 'Watch/admin/slider/images');
        const snapshot = await get(slidesRef);
        if (snapshot.exists()) {
          const slidesData = Object.entries(snapshot.val()).map(([id, slide]) => ({
            id,
            ...slide,
          }));
          setSlides(slidesData);
        }
      } catch (error) {
        toast.error('Failed to load images');
      } finally {
        setLoading(false);
      }
    };
    fetchSlides();
  }, []);

  useEffect(() => {
    if (slides.length > 1 && !isHovered) {
      intervalRef.current = setInterval(() => {
        setDirection(1);
        setCurrentIndex(prev => (prev + 1) % slides.length);
      }, 5000);
    } else {
      clearInterval(intervalRef.current);
    }
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [slides.length, isHovered]);

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  const goToSlide = (index) => {
    setDirection(index > currentIndex ? 1 : -1);
    setCurrentIndex(index);
  };

  const goToNext = () => {
    setDirection(1);
    setCurrentIndex(prev => (prev + 1) % slides.length);
  };

  const goToPrev = () => {
    setDirection(-1);
    setCurrentIndex(prev => (prev - 1 + slides.length) % slides.length);
  };

  // Touch swipe functionality
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => setTouchEnd(e.targetTouches[0].clientX);

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe && slides.length > 1) {
      goToNext();
    } else if (isRightSwipe && slides.length > 1) {
      goToPrev();
    }

    setTouchStart(null);
    setTouchEnd(null);
  };

  const slideVariants = {
    enter: (direction) => ({
      opacity: 0,
      x: direction > 0 ? 1000 : -1000,
      scale: 0.95
    }),
    center: {
      opacity: 1,
      x: 0,
      scale: 1
    },
    exit: (direction) => ({
      opacity: 0,
      x: direction < 0 ? 1000 : -1000,
      scale: 0.95
    }),
  };

  const getResponsiveStyles = () => {
    const { isMobile, isTablet, isDesktop, isLargeDesktop, width, height } = screenSize;

    const containerHeight = isMobile ? height : '100vh';
    const navButtonSize = isMobile ? 50 : isTablet ? 55 : 60;
    const navButtonPosition = isMobile ? 15 : isTablet ? 25 : 40;
    const contentPadding = isMobile ? 15 : isTablet ? 25 : 40;
    const overlayPadding = isMobile ? '15px' : isTablet ? '5%' : '10%';

    return {
      sliderContainer: {
        position: 'relative',
        width: '100%',
        height: containerHeight,
        overflow: 'hidden',
        minHeight: isMobile ? '100vh' : '70vh',
        background: colors.primary, // FIXED: Prevents white background during transitions
      },
      slideContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
      },
      imageWrapper: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        background: colors.primary, // FIXED: Prevents white flash
      },
      productImage: {
        width: '100%',
        height: '100%',
        objectFit: isMobile ? 'cover' : 'cover',
        objectPosition: 'center',
        transition: 'transform 0.8s cubic-bezier(0.16, 1, 0.3, 1)',
        transform: isHovered && !isMobile ? 'scale(1.03)' : 'scale(1)',
        willChange: 'transform', // FIXED: Improves performance
      },
      overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: isMobile
          ? `linear-gradient(to bottom, transparent 0%, ${colors.overlay} 60%)`
          : `linear-gradient(to right, ${colors.overlay} 0%, transparent 100%)`,
        display: 'flex',
        alignItems: isMobile ? 'flex-end' : 'center',
        justifyContent: isMobile ? 'center' : 'flex-start',
        padding: overlayPadding,
        paddingBottom: isMobile ? '120px' : overlayPadding,
      },
      contentContainer: {
        maxWidth: (() => {
          if (isMobile) return width <= 480 ? '90%' : '85%';
          if (isTablet) return '70%';
          if (isLargeDesktop) return '700px';
          return '600px';
        })(),
        width: isMobile ? '100%' : 'auto',
        padding: contentPadding,
        background: colors.glass,
        backdropFilter: 'blur(10px)',
        borderRadius: isMobile ? '12px' : '16px',
        border: `1px solid rgba(255,255,255,0.1)`,
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
        transform: isHovered && !isMobile ? 'translateY(-10px)' : 'translateY(0)',
        transition: 'all 0.6s cubic-bezier(0.16, 1, 0.3, 1)',
        textAlign: isMobile ? 'center' : 'left',
      },
      productTitle: {
        fontSize: (() => {
          if (isMobile) return width <= 480 ? '1.8rem' : '2.2rem';
          if (isTablet) return '2.8rem';
          if (isLargeDesktop) return '4.5rem';
          return '4rem';
        })(),
        fontWeight: 300,
        color: colors.textLight,
        marginBottom: isMobile ? '15px' : '20px',
        lineHeight: 1.1,
        letterSpacing: isMobile ? '0.5px' : '1px',
      },
      productDescription: {
        fontSize: (() => {
          if (isMobile) return width <= 480 ? '0.9rem' : '1rem';
          if (isTablet) return '1.1rem';
          return '1.2rem';
        })(),
        fontWeight: 300,
        color: colors.textMuted,
        marginBottom: isMobile ? '25px' : '40px',
        lineHeight: 1.6,
        display: isMobile && width <= 480 ? '-webkit-box' : 'block',
        WebkitLineClamp: isMobile && width <= 480 ? 3 : 'none',
        WebkitBoxOrient: 'vertical',
        overflow: isMobile && width <= 480 ? 'hidden' : 'visible',
      },
      priceTag: {
        display: 'inline-block',
        background: colors.accent,
        color: colors.primary,
        padding: isMobile ? '6px 16px' : '8px 20px',
        borderRadius: '20px',
        fontSize: isMobile ? '1rem' : '1.2rem',
        fontWeight: 500,
        marginBottom: isMobile ? '20px' : '30px',
      },
      ctaButton: {
        background: 'transparent',
        color: colors.textLight,
        border: `2px solid ${colors.accent}`,
        padding: (() => {
          if (isMobile) return width <= 480 ? '12px 30px' : '14px 35px';
          if (isTablet) return '14px 38px';
          return '15px 40px';
        })(),
        fontSize: isMobile ? '0.9rem' : '1rem',
        fontWeight: 500,
        letterSpacing: isMobile ? '1px' : '1.5px',
        cursor: 'pointer',
        transition: 'all 0.4s ease',
        borderRadius: '30px',
        position: 'relative',
        overflow: 'hidden',
        width: isMobile ? '100%' : 'auto',
        maxWidth: isMobile ? '280px' : 'none',
        touchAction: isMobile ? 'manipulation' : 'auto',
      },
      navButton: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: navButtonSize,
        height: navButtonSize,
        borderRadius: '50%',
        background: colors.glass,
        backdropFilter: 'blur(5px)',
        border: `1px solid rgba(255,255,255,0.2)`,
        display: isMobile && width <= 480 ? 'none' : 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        zIndex: 10,
        color: colors.textLight,
        left: navButtonPosition,
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        touchAction: 'manipulation',
        WebkitTapHighlightColor: 'transparent',
      },
      pagination: {
        position: 'absolute',
        bottom: isMobile ? '30px' : '40px',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: isMobile ? '8px' : '12px',
        zIndex: 10,
        padding: isMobile ? '10px' : '0',
        background: isMobile ? 'rgba(0,0,0,0.1)' : 'transparent',
        borderRadius: isMobile ? '20px' : '0',
        backdropFilter: isMobile ? 'blur(5px)' : 'none',
      },
      indicator: {
        width: isMobile ? '8px' : '10px',
        height: isMobile ? '8px' : '10px',
        borderRadius: '50%',
        background: colors.textMuted,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        touchAction: 'manipulation',
        border: 'none',
        outline: 'none',
      },
      slideNumber: {
        position: 'absolute',
        bottom: isMobile ? '30px' : '40px',
        right: isMobile ? '20px' : '40px',
        fontSize: isMobile ? '0.8rem' : '0.9rem',
        color: colors.textLight,
        letterSpacing: isMobile ? '1px' : '2px',
        opacity: 0.7,
        display: isMobile && width <= 480 ? 'none' : 'block',
        background: isMobile ? 'rgba(0,0,0,0.2)' : 'transparent',
        padding: isMobile ? '8px 12px' : '0',
        borderRadius: isMobile ? '12px' : '0',
        backdropFilter: isMobile ? 'blur(5px)' : 'none',
      }
    };
  };

  const sliderStyles = getResponsiveStyles();

  if (loading) {
    return (
      <div style={{
        height: screenSize.isMobile ? screenSize.height : '100vh',
        minHeight: screenSize.isMobile ? '100vh' : '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: colors.primary
      }}>
        <div style={{
          width: screenSize.isMobile ? '50px' : '60px',
          height: screenSize.isMobile ? '50px' : '60px',
          border: `3px solid ${colors.glass}`,
          borderTopColor: colors.accent,
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
      </div>
    );
  }

  if (slides.length === 0) {
    return (
      <div style={{
        height: screenSize.isMobile ? screenSize.height : '100vh',
        minHeight: screenSize.isMobile ? '100vh' : '70vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: colors.primary,
        color: colors.textLight,
        padding: '20px',
        textAlign: 'center'
      }}>
        <p style={{ fontSize: screenSize.isMobile ? '1rem' : '1.2rem' }}>
          No products available
        </p>
      </div>
    );
  }

  return (
    <div
      onMouseEnter={() => !screenSize.isMobile && setIsHovered(true)}
      onMouseLeave={() => !screenSize.isMobile && setIsHovered(false)}
      onTouchStart={screenSize.isMobile ? onTouchStart : undefined}
      onTouchMove={screenSize.isMobile ? onTouchMove : undefined}
      onTouchEnd={screenSize.isMobile ? onTouchEnd : undefined}
      style={{
        ...sliderStyles.sliderContainer,
        touchAction: screenSize.isMobile ? 'pan-y' : 'auto'
      }}
      ref={sliderRef}
    >
      <AnimatePresence initial={false} mode="wait" custom={direction}>
        <motion.div
          key={currentIndex}
          style={sliderStyles.slideContainer}
          custom={direction}
          variants={slideVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            x: { type: "spring", stiffness: 300, damping: 30 },
            opacity: { duration: 0.5 },
            scale: { duration: 0.5 }
          }}
        >
          <div style={sliderStyles.imageWrapper}>
            <img
              src={slides[currentIndex]?.url}
              alt={slides[currentIndex]?.altText || 'Luxury product'}
              style={{
                ...sliderStyles.productImage,
                opacity: imagesLoaded[currentIndex] ? 1 : 0,
              }}
              loading="eager"
            />
          </div>

          <div style={sliderStyles.overlay}>
            <motion.div
              style={sliderStyles.contentContainer}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              <h2
                className="slider-title"
                style={{
                ...sliderStyles.productTitle,
                background: 'linear-gradient(90deg, #ff8a00, #e52e71)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                fontSize: screenSize.isMobile ? '2.5rem' : '4rem',
                lineHeight: 1.1
              }}
              >
                {slides[currentIndex]?.title || 'Premium Collection'}
              </h2>

              {slides[currentIndex]?.price && (
                <div style={sliderStyles.priceTag}>
                  ${slides[currentIndex]?.price}
                </div>
              )}
              <p
                className="slider-description"
                style={sliderStyles.productDescription}
              >
                {slides[currentIndex]?.description || 'Discover our exclusive range of luxury timepieces and eyewear'}
              </p>

             <motion.button
              style={{
                ...sliderStyles.ctaButton,
                background: 'linear-gradient(90deg, #ff8a00, #e52e71)',
                border: 'none',
                color: 'white',
                fontWeight: 'bold',
                letterSpacing: '1px',
                textTransform: 'uppercase',
                boxShadow: '0 4px 15px rgba(255,138,0,0.4)',
                padding: screenSize.isMobile ? '12px 30px' : '15px 40px',
                fontSize: screenSize.isMobile ? '0.9rem' : '1rem'
              }}
              onClick={() => navigate(slides[currentIndex]?.link || '/Products')}
              initial={{ opacity: 0, y: 30 }}
              animate={{ 
                opacity: 1, 
                y: 0,
                transition: { delay: 0.9 }
              }}
              whileHover={!screenSize.isMobile ? {
                scale: 1.05,
                boxShadow: '0 6px 20px rgba(255,138,0,0.6)',
                background: 'linear-gradient(90deg, #ff9a00, #f22e81)'
              } : {}}
              whileTap={{ scale: 0.95 }}
            >
              EXPLORE COLLECTION
            </motion.button>
            </motion.div>
          </div>
        </motion.div>
      </AnimatePresence>

      {!(screenSize.isMobile && screenSize.width <= 480) && (
        <>
          <button
            style={sliderStyles.navButton}
            onClick={goToPrev}
            aria-label="Previous slide"
            onTouchStart={(e) => e.preventDefault()}
          >
            <svg
              width={screenSize.isMobile ? "20" : "24"}
              height={screenSize.isMobile ? "20" : "24"}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>

          <button
            style={{
              ...sliderStyles.navButton,
              left: 'auto',
              right: screenSize.isMobile ? '15px' : screenSize.isTablet ? '25px' : '40px'
            }}
            onClick={goToNext}
            aria-label="Next slide"
            onTouchStart={(e) => e.preventDefault()}
          >
            <svg
              width={screenSize.isMobile ? "20" : "24"}
              height={screenSize.isMobile ? "20" : "24"}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>
        </>
      )}

      <div style={sliderStyles.slideNumber}>
        {String(currentIndex + 1).padStart(2, '0')} / {String(slides.length).padStart(2, '0')}
      </div>

      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }

          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes slideInFromLeft {
            from {
              opacity: 0;
              transform: translateX(-50px);
            }
            to {
              opacity: 1;
              transform: translateX(0);
            }
          }

          @media (max-width: 480px) {
            .slider-title {
              font-size: 1.8rem !important;
              line-height: 1.2;
            }

            .slider-description {
              font-size: 0.9rem !important;
              margin-bottom: 20px !important;
            }

            .slider-button {
              width: 100% !important;
              max-width: 280px !important;
              padding: 12px 30px !important;
            }
          }

          @media (min-width: 481px) and (max-width: 767px) {
            .slider-title {
              font-size: 2.2rem !important;
            }

            .slider-description {
              font-size: 1rem !important;
            }
          }

          @media (min-width: 768px) and (max-width: 1023px) {
            .slider-title {
              font-size: 2.8rem !important;
            }

            .slider-description {
              font-size: 1.1rem !important;
            }
          }

          @media (min-width: 1440px) {
            .slider-title {
              font-size: 4.5rem !important;
            }

            .slider-description {
              font-size: 1.3rem !important;
            }
          }

          @media (hover: none) and (pointer: coarse) {
            button {
              min-height: 44px;
              min-width: 44px;
            }
          }

          @media screen and (-webkit-min-device-pixel-ratio: 0) {
            select, textarea, input[type="text"], input[type="password"],
            input[type="datetime"], input[type="datetime-local"],
            input[type="date"], input[type="month"], input[type="time"],
            input[type="week"], input[type="number"], input[type="email"],
            input[type="url"] {
              font-size: 16px;
            }
          }
        `}
      </style>
    </div>
  );
};

export default LuxuryProductSlider;
